document.addEventListener('DOMContentLoaded', () => {
  const preloader = document.querySelector('.preloader');
  const header = document.querySelector('header.page__header');
  const main = document.querySelector('main.page__main');
  const mainInner = document.querySelector('main.page__inner');

  if (!preloader || !header) return;

  if (document.cookie.indexOf('preload=loaded') === -1) {
    preloader.classList.add('preloader--shown');
    document.cookie = 'preload=loaded';

    header.classList.remove('preload');

    if (main) {
      main.classList.remove('preload');
    } else if (mainInner) {
      mainInner.classList.remove('preload');
    }

    setTimeout(() => {
      preloader.className = 'preloader preloader--hidden';
      preloader.innerHTML = '';
    }, 4000)
  } else {
    preloader.className = 'preloader preloader--hidden';
    preloader.innerHTML = '';
    header.classList.remove('preload');

    if (main) {
      main.classList.remove('preload');
    } else if (mainInner) {
      mainInner.classList.remove('preload');
    }
  }
});
